var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.2 129.3",
    style: {
      enableBackground: "new 0 0 129.2 129.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:url(#SVGID_1_);}\r\n\t.st2{display:inline;opacity:0.2;fill:url(#SVGID_00000128469322146047317540000002107910184361652130_);}\r\n\t.st3{display:inline;}\r\n\t.st4{fill:#FDFEFE;}\r\n\t.st5{display:inline;fill:url(#SVGID_00000106849610353526250210000000147696323643560862_);}\r\n\t.st6{display:inline;fill:url(#SVGID_00000183244015231853079890000011927199329642490260_);}\r\n\t.st7{display:inline;fill:url(#SVGID_00000175305812619927734140000004583470887880480695_);}\r\n\t.st8{display:inline;fill:url(#SVGID_00000163048523166148137630000011772278354851043238_);}\r\n\t.st9{display:inline;opacity:0.2;}\r\n\t.st10{fill:url(#SVGID_00000024711472005707959930000016029360691001315999_);}\r\n\t.st11{fill:url(#SVGID_00000170957342832502213600000000103917142397794689_);}\r\n\t.st12{display:inline;fill:url(#SVGID_00000023980553371997437230000009977826221593078970_);}\r\n\t.st13{display:inline;fill:url(#SVGID_00000073685744571365840450000014987132050548781733_);}\r\n\t.st14{fill:url(#SVGID_00000121980826082297170410000005527945246757536641_);}\r\n\t.st15{fill:url(#SVGID_00000073708424563895906340000008287059205744258183_);}\r\n\t.st16{fill:url(#SVGID_00000025410360574492728230000015066937423128366760_);}\r\n\t.st17{fill:#FFFFFF;}\r\n\t.st18{fill:none;stroke:#FDFEFE;stroke-miterlimit:10;}\r\n\t.st19{fill:url(#SVGID_00000000201985218203843640000007912799680497168035_);}\r\n\t.st20{opacity:0.2;}\r\n\t.st21{fill:url(#SVGID_00000153689650154036465760000012828030519509926068_);}\r\n\t.st22{fill:url(#SVGID_00000155109247901497881940000016421464074809077145_);}\r\n\t.st23{fill:url(#SVGID_00000121242030748389689910000011740195384920861622_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "bkgrnd",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.9456,
    y1: 14.8275,
    x2: 113.8485,
    y2: 113.7304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.7-0.1H48.4C21.7-0.1,0,21.6,0,48.3v32.3c0,26.8,21.7,48.4,48.4,48.4h32.3c26.8,0,48.4-21.7,48.4-48.4V48.3 C129.2,21.6,107.5-0.1,80.7-0.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150062437066898352200000004635490146262136747_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5068,
    y1: 77.9586,
    x2: 128.6046,
    y2: 77.9586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.2,
      fill: "url(#SVGID_00000150062437066898352200000004635490146262136747_)"
    },
    d: "M61.6,128.1 L20.5,83.3l15.6-24.9h5.3L31.3,43.3l17.8-15l18.2,24.8c0,0-5.2-10.6,0-10.1S82,60,82,60s16.8,3.1,10-0.3 c-6.8-3.3-16.4-16.5-16.4-16.5s16.5-14.1,17.1-15.6c0.6-1.5,39,42.1,35.7,51.5s-0.3,31.7-27.5,44.8 C100.9,124.1,93,129.3,61.6,128.1z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.7,100.6c-3.8,0-7.7,0-11.5,0c-0.3,0-0.3,0-0.3-0.3c0-3.3,0-6.6,0-10c0-0.2,0-0.3-0.3-0.3 c-0.5,0-0.9,0-1.4,0c-0.2,0-0.3,0.1-0.3,0.3c0,2.6,0,5.2,0,7.8c0,0.7,0,1.5,0,2.2c0,0.2,0,0.3-0.2,0.3c-2.3,0-4.6,0-6.9,0 c-0.2,0-0.3-10.7-0.2-16c0-2.5,0.8-4.8,2.3-6.8c1-1.4,2.3-2.4,3.8-3.2c1.3-0.7,2.7-1.2,4.1-1.5c0.7-0.1,1.3-0.2,2-0.3 c0.7-0.1,1.3,0,2,0c4.9,0,9.8,0,14.7,0c2.1,0,4.1,0.5,6,1.3c1.5,0.7,2.8,1.6,3.9,2.8c1.4,1.5,2.3,3.2,2.7,5.2 c0.2,0.7,0.2,1.4,0.3,2.1c0.1,0.8,0,1.6,0,2.3c0,4.6,0,9.1,0,13.7c0,0.3,0,0.3-0.3,0.3c-2.1,0-4.3,0-6.4,0c-0.2,0-0.3-0.1-0.3-0.3 c0-3.3,0-6.6,0-9.9c0-0.4,0-0.3-0.3-0.3c-0.4,0-0.9,0-1.3,0c-0.2,0-0.3,0-0.3,0.3c0,1,0,1.9,0,2.9c0,2.4,0,4.8,0,7.2 c0,0.2-0.1,0.3-0.3,0.3C71.4,100.6,67.6,100.6,63.7,100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.6,75.2c0,2.7,0,5.3,0,8c0,0.2,0,0.3-0.3,0.3c-2.2,0-4.3,0-6.5,0c-0.2,0-0.3-0.1-0.3-0.3 c0-3.3,0-6.7,0-10c0-0.2-0.1-0.3-0.3-0.3c-0.4,0-0.9,0-1.3,0c-0.2,0-0.3,0.1-0.3,0.3c0,3.3,0,6.6,0,9.9c0,0.4,0,0.3-0.3,0.3 c-3.4,0-6.8,0-10.2,0c-0.2,0-0.3-0.1-0.3-0.3c-0.1-1.4-0.5-2.8-1.1-4.2c-0.5-1.1-1.1-2.1-1.8-3.1c-1-1.3-2.3-2.4-3.7-3.3 c-1.8-1.1-3.7-1.8-5.7-2.1c-0.7-0.1-1.3-0.2-2-0.2c-2.3-0.1-4.6,0-6.9,0c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2-0.2c0-0.3,0-0.7,0-1 c0-0.1,0.1-0.2,0.2-0.2c0.9-0.1,1.9-0.3,2.8-0.6c1.1-0.3,2.1-0.8,3-1.4c1-0.6,2-1.4,2.8-2.3c1.7-1.8,2.9-3.8,3.5-6.2 c0.2-0.9,0.4-1.7,0.5-2.6c0-0.1,0.1-0.2,0.2-0.2c0.2,0,0.3,0,0.5,0c5.2,0,10.4,0,15.6,0c1.8,0,3.6,0.4,5.3,1.1 c1.4,0.6,2.6,1.3,3.7,2.4c1.8,1.7,2.9,3.8,3.4,6.2c0.2,0.9,0.2,1.8,0.2,2.6C106.6,70.5,106.6,72.8,106.6,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.5,75.2c0-2.6,0-5.1,0-7.7c0-2.3,0.7-4.5,2-6.4c1.3-1.9,3.1-3.3,5.2-4.2c1.3-0.6,2.7-0.9,4.2-1.1 c0.6-0.1,1.2-0.1,1.8-0.1c5.1,0,10.3,0,15.4,0c0.3,0,0.3,0,0.4,0.4c0.1,1.3,0.4,2.5,0.9,3.7c0.6,1.5,1.4,2.9,2.4,4.1 c1.1,1.4,2.5,2.5,4,3.3c1.5,0.8,3.1,1.4,4.7,1.6c0.2,0,0.4,0,0.6,0.1c0.1,0,0.2,0.1,0.2,0.2c0,0.3,0,0.6,0,0.9 c0,0.2-0.1,0.2-0.3,0.2c-1.6,0-3.2,0-4.7,0c-0.7,0-1.4,0-2.1,0c-2,0.1-3.9,0.4-5.7,1.1c-1.5,0.6-2.9,1.3-4.1,2.3 c-1.4,1.1-2.5,2.4-3.4,3.9c-0.7,1.2-1.2,2.4-1.5,3.7c-0.2,0.7-0.3,1.4-0.4,2.1c0,0.1,0,0.2-0.2,0.2c0,0-0.1,0-0.1,0 c-3.3,0-6.6,0-9.9,0c-0.3,0-0.3,0-0.3-0.3c0-3.3,0-6.6,0-10c0-0.2-0.1-0.3-0.3-0.3c-0.5,0-0.9,0-1.4,0c-0.2,0-0.3,0.1-0.3,0.3 c0,3.3,0,6.6,0,9.8c0,0.5,0,0.5-0.5,0.5c-2.2,0-4.4,0-6.6,0c-0.2,0-0.3-0.1-0.3-0.3C20.5,80.6,20.5,77.9,20.5,75.2 C20.5,75.2,20.5,75.2,20.5,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.4,37.3c0,1.8-0.4,3.5-1.1,5.2c-0.7,1.5-1.7,2.8-2.9,3.9c-1.6,1.4-3.4,2.3-5.5,2.7 c-0.8,0.2-1.7,0.2-2.6,0.2c-2-0.1-3.9-0.7-5.5-1.7c-1.7-1.1-3.1-2.5-4.1-4.3c-0.8-1.4-1.2-2.8-1.4-4.4c-0.3-2.3,0-4.6,1-6.8 c0.5-1.2,1.3-2.3,2.2-3.2c1.6-1.7,3.5-2.8,5.7-3.4c1.1-0.3,2.2-0.4,3.3-0.3c2.3,0.2,4.4,0.9,6.3,2.4c2.1,1.6,3.5,3.7,4.2,6.2 c0.3,0.9,0.4,1.8,0.5,2.7C97.4,36.8,97.4,37.1,97.4,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.8,37.5c0-2.2,0.5-4.2,1.4-6c1.1-2.1,2.7-3.7,4.7-4.8c1.2-0.7,2.5-1.1,3.9-1.3c2.4-0.3,4.7,0.1,6.8,1.2 c0.9,0.5,1.7,1,2.4,1.7c1.6,1.5,2.7,3.2,3.4,5.3c0.3,0.9,0.5,1.9,0.5,2.9c0.1,1.7-0.1,3.3-0.6,4.9c-0.5,1.4-1.2,2.7-2.2,3.9 c-1.1,1.2-2.3,2.2-3.8,3c-1.2,0.6-2.4,0.9-3.7,1.1c-2.5,0.3-4.8-0.2-7-1.4c-1.9-1.1-3.4-2.6-4.5-4.5c-0.7-1.3-1.2-2.7-1.4-4.2 C29.8,38.5,29.7,37.9,29.8,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.2,54.3c0,2.2-0.5,4.1-1.4,5.9c-1.1,2-2.6,3.6-4.5,4.8c-1.3,0.8-2.7,1.2-4.2,1.4c-2.1,0.3-4.1,0-6-0.8 c-1.4-0.6-2.7-1.5-3.7-2.6c-1.7-1.7-2.8-3.8-3.2-6.2c-0.2-1-0.3-1.9-0.2-2.9c0.1-2,0.6-3.8,1.6-5.5c0.6-1,1.2-1.9,2.1-2.7 c1.7-1.6,3.7-2.7,6.1-3.1c0.8-0.1,1.7-0.2,2.5-0.2c2.4,0.1,4.5,0.9,6.4,2.4c2.3,1.8,3.7,4.1,4.4,6.8 C75.2,52.5,75.3,53.5,75.2,54.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071526499842844163960000000213007535091114927_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4023,
    y1: 64.8789,
    x2: 0.4023,
    y2: 64.8789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000071526499842844163960000000213007535091114927_)"
    },
    d: "M0.4,80.9V48.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113334548659716892140000006754750130309692074_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5557,
    y1: 129.0834,
    x2: 80.6579,
    y2: 129.0834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000113334548659716892140000006754750130309692074_)"
    },
    d: "M80.7,129.1H48.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106146671103053167470000015800998959237145525_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4023,
    y1: 64.8693,
    x2: 0.4023,
    y2: 64.8693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000106146671103053167470000015800998959237145525_)"
    },
    d: "M0.4,80.9V48.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031195369368926681790000004617566146494982019_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5557,
    y1: 127.6024,
    x2: 97.2441,
    y2: 127.6024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000031195369368926681790000004617566146494982019_)"
    },
    d: "M97.2,126.1 c-1.7,0.6-3.4,1.2-5.2,1.6c-3.7,0.9-7.5,1.4-11.4,1.4H48.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001666098131221657830000003133061654325185181_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.5111,
    y1: 128.3916,
    x2: 92.0542,
    y2: 128.3916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001666098131221657830000003133061654325185181_)"
    },
    d: "M92.1,127.7c-3.7,0.9-7.5,1.4-11.4,1.4 H55.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095308796495188515630000005327646064684471197_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.2441,
    y1: 126.131,
    x2: 97.2441,
    y2: 126.131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095308796495188515630000005327646064684471197_)"
    },
    d: "M97.2,126.1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051347710360314067120000013393767792155528850_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.00003021635,
    y1: 64.4717,
    x2: 128.924,
    y2: 64.4717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000051347710360314067120000013393767792155528850_)"
    },
    d: "M48.3,0l32.2,0 c26.7,0,48.3,21.6,48.3,48.3v32.2c0,26.7-21.6,48.3-48.3,48.3H48.3C21.6,128.9,0,107.3,0,80.6l0-32.2C0,21.7,21.6,0,48.3,0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114060486838275118350000005638429491901998468_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 64.462,
    x2: 128.924,
    y2: 64.462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000114060486838275118350000005638429491901998468_)"
    },
    d: "M128.9,48.3v32.2 c0,3.9-0.5,7.8-1.4,11.5c-0.4,1.7-0.9,3.5-1.6,5.2c-4.9,13.3-15.4,23.9-28.7,28.7c-1.7,0.6-3.4,1.2-5.2,1.6 c-3.7,0.9-7.5,1.4-11.4,1.4H48.3C21.6,128.9,0,107.3,0,80.6V48.3C0,21.6,21.6,0,48.3,0h32.2C107.3,0,128.9,21.6,128.9,48.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001630685149266209050000014737597618648072345_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8541,
    y1: 104.7505,
    x2: 92.0195,
    y2: 104.7505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001630685149266209050000014737597618648072345_)"
    },
    d: "M92,127.6c-3.7,0.9-7.5,1.4-11.4,1.4 H55.3L28,101.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.6-0.9-1.6-0.7-2.4l3.4-16.1c0.3-1.5,1.7-2.4,3.2-2.1c1.5,0.3,2.4,1.7,2.1,3.2 L34,91.1l8.9-8.9c1-1,2.7-1,3.8,0L92,127.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004540104010551033980000003634860765600627087_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8541,
    y1: 76.4131,
    x2: 125.9695,
    y2: 76.4131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004540104010551033980000003634860765600627087_)"
    },
    d: "M126,97.2 c-4.9,13.3-15.4,23.9-28.7,28.7L50.1,78.9l0.1,0c-3.7-3.7-6-8.8-6-14.4c0-1.2,0.1-2.3,0.3-3.4L31.2,47.8 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.5-0.7-0.6-1.2l-3.4-16.1c-0.2-0.9,0.1-1.8,0.7-2.5c0.6-0.6,1.6-0.9,2.4-0.7l16.1,3.4 c0.6,0.2,1.2,0.5,1.6,1l0.1,0.1L61,44.5c1.1-0.2,2.3-0.3,3.4-0.3c6,0,11.4,2.6,15.1,6.8l0.3,0.1L126,97.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087394742778249422350000002165935655743539128_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.5758,
    y1: 59.465,
    x2: 128.924,
    y2: 59.465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087394742778249422350000002165935655743539128_)"
    },
    d: "M128.9,55.3v25.3 c0,3.9-0.5,7.8-1.4,11.5L82.2,46.7c-1-1-1-2.8,0-3.8l8.9-8.9l-7.3,1.5c-1.5,0.3-2.9-0.6-3.2-2.1c-0.3-1.5,0.6-2.9,2.1-3.2 l16.1-3.4c0.9-0.2,1.8,0.1,2.4,0.7L128.9,55.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M48.3,33.5c-0.3,1.5-1.7,2.4-3.2,2.1L37.8,34l8.9,8.9c1,1,1,2.8,0,3.8c-0.5,0.5-1.2,0.8-1.9,0.8 c-0.7,0-1.4-0.3-1.9-0.8L34,37.8l1.5,7.3c0.3,1.5-0.6,2.9-2.1,3.2c-0.2,0-0.4,0.1-0.6,0.1c-1.2,0-2.4-0.9-2.6-2.1l-3.4-16.1 c-0.2-0.9,0.1-1.8,0.7-2.5c0.6-0.6,1.6-0.9,2.4-0.7l16.1,3.4C47.7,30.6,48.6,32,48.3,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M48.3,95.5c0.3,1.5-0.6,2.9-2.1,3.2L30.1,102c-0.2,0-0.3,0.1-0.5,0.1c-0.7,0-1.4-0.3-1.9-0.8 c-0.6-0.6-0.9-1.6-0.7-2.4l3.4-16.1c0.3-1.5,1.7-2.4,3.2-2.1c1.5,0.3,2.4,1.7,2.1,3.2L34,91.1l8.9-8.9c1-1,2.7-1,3.8,0 c1,1,1,2.7,0,3.8l-8.9,8.9l7.3-1.5C46.6,93.1,48,94,48.3,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M102,98.9c0.2,0.9-0.1,1.8-0.8,2.4c-0.5,0.5-1.2,0.8-1.9,0.8c-0.2,0-0.4,0-0.6-0.1l-16.1-3.4 c-1.5-0.3-2.4-1.7-2.1-3.2c0.3-1.5,1.7-2.4,3.2-2.1l7.3,1.5L82.2,86c-1-1-1-2.7,0-3.8c1-1,2.8-1,3.8,0l8.9,8.9l-1.5-7.3 c-0.3-1.5,0.6-2.9,2.1-3.2c1.5-0.3,2.9,0.6,3.2,2.1L102,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M80.6,33.5c-0.3-1.5,0.6-2.9,2.1-3.2l16.1-3.4c0.9-0.2,1.8,0.1,2.4,0.7c0.6,0.6,0.9,1.6,0.8,2.5 l-3.4,16.1c-0.3,1.3-1.4,2.1-2.6,2.1c-0.2,0-0.3,0-0.5-0.1c-1.5-0.3-2.4-1.7-2.1-3.2l1.5-7.3L86,46.7c-0.5,0.5-1.2,0.8-1.9,0.8 c-0.7,0-1.4-0.3-1.9-0.8c-1-1-1-2.8,0-3.8l8.9-8.9l-7.3,1.5C82.3,35.9,80.9,34.9,80.6,33.5z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M58,84.2c0-2.1-0.1-7.9,0-9.9c0-0.1,0-0.2-0.2-0.2c-0.3,0-0.5,0-0.8,0c-0.1,0-0.2,0-0.2,0.2 c0,1.6,0,3.1,0,4.7c0,0.4,0,0.9,0,1.3c0,2.4,0,3.2,0,3.4C57.2,83.9,57.6,84,58,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M73,80.2c0-2,0-4,0-5.9c0-0.2,0-0.2-0.2-0.2c-0.3,0-0.5,0-0.8,0c-0.1,0-0.2,0-0.2,0.2c0,0.6,0,1.1,0,1.7 c0,1.4,0.1,6.3,0.1,8c0.4-0.1,0.8-0.3,1.1-0.5C72.9,83.4,73,80.4,73,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M64.8,44.2c-11.2,0-20.3,9.2-20.3,20.6c0,6.7,3.2,12.6,8.1,16.4c-0.1-0.4-0.1-7.2,0-10.3 c0-1.5,0.5-2.9,1.3-4.1c0.6-0.8,1.4-1.4,2.2-1.9c0.8-0.4,1.6-0.7,2.4-0.9c0.4-0.1,0.8-0.1,1.2-0.2c0.4,0,0.8,0,1.2,0 c2.9,0,5.8,0,8.6,0c1.2,0,2.4,0.3,3.5,0.8c0.9,0.4,1.7,1,2.3,1.7c0.8,0.9,1.3,1.9,1.6,3.1c0.1,0.4,0.1,0.8,0.2,1.2 c0,0.5,0,0.9,0,1.4c0,2.7,0,6.4,0,9.1c4.9-3.8,8-9.7,8-16.4C85.1,53.4,76,44.2,64.8,44.2z M70.8,56.3c-0.6,1.2-1.5,2.1-2.7,2.8 c-0.8,0.5-1.6,0.7-2.4,0.9c-1.2,0.2-2.4,0-3.5-0.5c-0.8-0.4-1.6-0.9-2.2-1.5c-1-1-1.6-2.3-1.9-3.7c-0.1-0.6-0.2-1.1-0.1-1.7 c0.1-1.2,0.4-2.3,0.9-3.3c0.3-0.6,0.7-1.1,1.2-1.6c1-1,2.2-1.6,3.6-1.9c0.5-0.1,1-0.1,1.5-0.1c1.4,0.1,2.7,0.5,3.8,1.4 c1.3,1,2.2,2.4,2.6,4.1c0.1,0.5,0.2,1.1,0.2,1.6C71.6,54.1,71.4,55.2,70.8,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M76.2,81.8C76.2,81.8,76.1,81.8,76.2,81.8C76.1,81.8,76.2,81.8,76.2,81.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 64.8,
    cy: 64.7,
    r: 20.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040566716985315956710000000652666483936750494_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.9456,
    y1: 15.0196,
    x2: 113.8485,
    y2: 113.9225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52B959"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040566716985315956710000000652666483936750494_)"
    },
    d: "M80.7,0.1H48.4C21.7,0.1,0,21.8,0,48.5 v32.3c0,26.8,21.7,48.4,48.4,48.4h32.3c26.8,0,48.4-21.7,48.4-48.4V48.5C129.2,21.8,107.5,0.1,80.7,0.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078760932755878600220000007082480261076521362_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.3791,
    y1: 55.5154,
    x2: 129.1852,
    y2: 55.5154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078760932755878600220000007082480261076521362_)"
    },
    d: "M129.2,62.1V81c0,1.9-0.1,3.8-0.3,5.6 L94.6,52.3L71.2,29c-0.5-0.5-0.9-1.2-0.9-1.9c0-1.4,1.2-2.6,2.6-2.6h13.6c0.9,0,1.7,0.1,2.5,0.2c1,0.2,1.9,0.5,2.7,0.9 c0.3,0.1,0.6,0.3,0.9,0.4c0.3,0.2,0.6,0.3,0.9,0.5c0.2,0.1,0.3,0.2,0.5,0.4c0.2,0.2,0.5,0.4,0.7,0.6c0.3,0.2,0.6,0.5,0.9,0.9 c0.1,0,0.1,0.1,0.1,0.1L129.2,62.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031897749182586791230000008313881963787286674_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4354,
    y1: 103.1339,
    x2: 86.3119,
    y2: 103.1339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031897749182586791230000008313881963787286674_)"
    },
    d: "M86.3,129.1c-1.8,0.2-3.7,0.3-5.6,0.3 H61.8l-27.6-27.6c-1.3-1.2-2.3-2.7-3-4.4l-6.8-6.8c-1.1-0.9-1.4-2.5-0.5-3.6l6.9-9.3c1-1.3,3.1-1.3,4.1,0l22.7,22.7 c0,0,0.1,0.1,0.1,0.1l0.6,0.6c0,0,0,0.1,0.1,0.1L86.3,129.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083067063676697316100000012147100553492796580_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.4207,
    y1: 76.6559,
    x2: 125.5787,
    y2: 76.6559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083067063676697316100000012147100553492796580_)"
    },
    d: "M125.6,99.3c-4.7,11.6-13.9,21-25.4,26.1 l-29-29c-1.4-1-2.6-2.2-3.6-3.6L35.7,60.8c0,0,0,0,0,0c-0.3-0.2-0.6-0.5-0.9-0.8c-0.6-0.5-1.2-1.1-1.7-1.7c-0.3-0.3-0.5-0.6-0.8-1 c-0.3-0.4-0.6-0.8-0.8-1.2c-0.6-0.8-1-1.7-1.4-2.6c-0.1-0.3-0.3-0.6-0.4-1c-0.2-0.3-0.3-0.7-0.4-1.1c-0.1-0.4-0.2-0.8-0.3-1.2 c-0.1-0.2-0.1-0.5-0.1-0.7c-0.1-0.5-0.2-1-0.2-1.5c-0.1-0.6-0.1-1.2-0.1-1.9c0-10.1,8.2-18.2,18.3-18.2c1.4,0,2.8,0.2,4.1,0.5 c0.4,0.1,0.9,0.2,1.3,0.3c2.9,0.9,5.4,2.4,7.5,4.5l35.4,35.4L125.6,99.3z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M56.2,100.1H42.6c-3.9,0-7.1-3.2-7.1-7.1l0-5.9l2.3,3.1c0.9,1.1,2.5,1.4,3.6,0.5c1.1-0.9,1.4-2.5,0.5-3.6 L35,77.8c-1-1.3-3.1-1.3-4.1,0L24,87.1c-0.9,1.1-0.6,2.7,0.5,3.6c0.5,0.3,1,0.5,1.5,0.5c0.8,0,1.6-0.4,2.1-1l2.3-3.1l0,5.9 c0,6.8,5.5,12.3,12.3,12.3h13.6c1.4,0,2.6-1.2,2.6-2.6C58.8,101.2,57.7,100.1,56.2,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.7,39c-1.1-0.9-2.7-0.6-3.6,0.5l-2.3,3.1v-5.9c0-6.8-5.5-12.3-12.3-12.3H72.9c-1.4,0-2.6,1.2-2.6,2.6 c0,1.4,1.2,2.6,2.6,2.6h13.6c3.9,0,7.1,3.2,7.1,7.1v5.9l-2.3-3.1c-0.8-1.1-2.5-1.4-3.6-0.5c-1.1,0.9-1.4,2.5-0.5,3.6l6.9,9.3 c0.5,0.6,1.2,1,2.1,1c0.8,0,1.6-0.4,2.1-1l6.9-9.3C106.1,41.5,105.9,39.8,104.7,39z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M40.5,63.2c0-1.9,0-7,0-8.7c0-0.1,0-0.2-0.1-0.1c-0.2,0-0.5,0-0.7,0c-0.1,0-0.1,0-0.1,0.1 c0,1.4,0,2.7,0,4.1c0,0.4,0,0.8,0,1.2c0,2.1,0,2.8,0,3C39.8,63,40.1,63.1,40.5,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M53.7,59.8c0-1.7,0-3.5,0-5.2c0-0.2,0-0.2-0.2-0.2c-0.2,0-0.5,0-0.7,0c-0.1,0-0.1,0-0.1,0.1 c0,0.5,0,1,0,1.5c0,1.2,0.1,5.6,0.1,7.1c0.3-0.1,0.7-0.3,1-0.4C53.7,62.6,53.7,59.9,53.7,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M46.5,28c-9.8,0-17.9,8.1-17.9,18.1c0,5.9,2.8,11.1,7.1,14.5c-0.1-0.3-0.1-6.4,0-9.1c0-1.3,0.4-2.5,1.2-3.6 c0.5-0.7,1.2-1.3,2-1.7c0.7-0.4,1.4-0.6,2.1-0.8c0.3-0.1,0.7-0.1,1-0.1c0.3,0,0.7,0,1,0c2.5,0,5.1,0,7.6,0c1.1,0,2.1,0.2,3.1,0.7 c0.8,0.4,1.5,0.8,2,1.5c0.7,0.8,1.2,1.7,1.4,2.7c0.1,0.4,0.1,0.7,0.1,1.1c0,0.4,0,0.8,0,1.2c0,2.4,0,5.6,0,8 c4.3-3.3,7.1-8.5,7.1-14.4C64.4,36.1,56.3,28,46.5,28z M51.8,38.7c-0.6,1.1-1.3,1.9-2.4,2.5c-0.7,0.4-1.4,0.6-2.2,0.8 c-1.1,0.1-2.1,0-3.1-0.4c-0.7-0.3-1.4-0.8-1.9-1.3c-0.9-0.9-1.4-2-1.7-3.2c-0.1-0.5-0.1-1-0.1-1.5c0.1-1,0.3-2,0.8-2.9 c0.3-0.5,0.6-1,1.1-1.4c0.9-0.9,1.9-1.4,3.1-1.6c0.4-0.1,0.9-0.1,1.3-0.1c1.2,0.1,2.3,0.5,3.3,1.2c1.2,0.9,1.9,2.1,2.3,3.6 c0.1,0.5,0.2,1,0.2,1.4C52.5,36.7,52.3,37.7,51.8,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M56.5,61.2C56.5,61.2,56.5,61.2,56.5,61.2C56.5,61.2,56.5,61.2,56.5,61.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 46.5,
    cy: 46.1,
    r: 18.1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M77.7,100.2c0-1.9,0-7,0-8.7c0-0.1,0-0.2-0.1-0.1c-0.2,0-0.5,0-0.7,0c-0.1,0-0.1,0-0.1,0.1 c0,1.4,0,2.7,0,4.1c0,0.4,0,0.8,0,1.2c0,2.1,0,2.8,0,3C77,100,77.4,100.1,77.7,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M90.9,96.8c0-1.7,0-3.5,0-5.2c0-0.2,0-0.2-0.2-0.2c-0.2,0-0.5,0-0.7,0c-0.1,0-0.1,0-0.1,0.1 c0,0.5,0,1,0,1.5c0,1.2,0.1,5.6,0.1,7.1c0.3-0.1,0.7-0.3,1-0.4C90.9,99.6,90.9,96.9,90.9,96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M83.7,65c-9.8,0-17.9,8.1-17.9,18.1c0,5.9,2.8,11.1,7.1,14.5c-0.1-0.3-0.1-6.4,0-9.1c0-1.3,0.4-2.5,1.2-3.6 c0.5-0.7,1.2-1.3,2-1.7c0.7-0.4,1.4-0.6,2.1-0.8c0.3-0.1,0.7-0.1,1-0.1c0.3,0,0.7,0,1,0c2.5,0,5.1,0,7.6,0c1.1,0,2.1,0.2,3.1,0.7 c0.8,0.4,1.5,0.8,2,1.5c0.7,0.8,1.2,1.7,1.4,2.7c0.1,0.4,0.1,0.7,0.1,1.1c0,0.4,0,0.8,0,1.2c0,2.4,0,5.6,0,8 c4.3-3.3,7.1-8.5,7.1-14.4C101.6,73.1,93.6,65,83.7,65z M89,75.7c-0.6,1.1-1.3,1.9-2.4,2.5c-0.7,0.4-1.4,0.6-2.2,0.8 c-1.1,0.1-2.1,0-3.1-0.4c-0.7-0.3-1.4-0.8-1.9-1.3c-0.9-0.9-1.4-2-1.7-3.2c-0.1-0.5-0.1-1-0.1-1.5c0.1-1,0.3-2,0.8-2.9 c0.3-0.5,0.6-1,1.1-1.4c0.9-0.9,1.9-1.4,3.1-1.6c0.4-0.1,0.9-0.1,1.3-0.1c1.2,0.1,2.3,0.5,3.3,1.2c1.2,0.9,1.9,2.1,2.3,3.6 c0.1,0.5,0.2,1,0.2,1.4C89.8,73.7,89.5,74.7,89,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.8,98.1C93.7,98.2,93.7,98.2,93.8,98.1C93.7,98.2,93.7,98.2,93.8,98.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 83.7,
    cy: 83.1,
    r: 18.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoaIcon);
export default __webpack_public_path__ + "static/media/DOA Icon.67655bb74de9665990aae1d824bf563d.svg";
export { ForwardRef as ReactComponent };